import { Box, IconButton } from "@mui/material";
import { ReactComponent as Bell } from "assets/alarm-bell-2.svg";
import Drawer from "components/common/Drawer";
import ButtonLink from "components/common/Link";
import Spinner from "components/common/Spinner/Spinner";
import Typography from "components/common/Typography";
import { uniq } from "lodash";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { RETRIEVE_NOTIFICATION_EVENT_TYPE, accessTypes } from "utils/CommonConstants";
import Delete from "./DeleteDialog";
import { deleteNotifications, fetchUsersAsync, getNotifications, putNotifications } from "./Notifications.slice";
import List from "./list";

function Index() {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const isLoading = useAppSelector((state) => state.Notifications.data.isLoading);
  const notifications = useAppSelector((state) => state.Notifications.data.list);
  const unreadNotifications = useAppSelector((state) => state.Notifications.data.unreadNotifications);
  const notifiedByList = notifications.map((item: any) => item.notifiedBy);
  const impersonationDetails = useAppSelector((state) => state.app.impersonationDetails);
  const isImpersonated = impersonationDetails?.isImpersonated;

  const getUsersData = () => {
    if (notifiedByList.length) {
      const uniqueUsersStr = uniq(notifiedByList).join(",");
      dispatch(fetchUsersAsync(uniqueUsersStr));
    }
  };

  const closeNotificationsHandler = () => {
    const payload = notifications.map((item: any) => {
      return { id: item.id, isRead: "Y" };
    });
    if (payload.length) dispatch(putNotifications({ notifications: payload }));
    setOpen(false);
  };

  const openNotificationsHandler = () => {
    dispatch(
      getNotifications({
        size: 30,
        eventType: RETRIEVE_NOTIFICATION_EVENT_TYPE
      })
    );
    getUsersData();
    setOpen(true);
  };

  const handleDeleteNotification = (id?: any) => {
    if (id) {
      dispatch(deleteNotifications({ id }));
    } else {
      setOpenDeleteDialog(true);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start"
        }}
        onClick={openNotificationsHandler}
      >
        <IconButton
          sx={{
            "&:hover, &:active, &:focus": {
              background: "none",
              border: "none"
            }
          }}
        >
          <Bell />
        </IconButton>
        {unreadNotifications > 0 && (
          <Box
            sx={{
              height: "16px",
              width: "16px",
              backgroundColor: tokens.Icon.Feeback.Alert,
              borderRadius: "50%",
              marginLeft: "-8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Typography variant={"label"} showBold color={tokens.Text.General.Inverse}>
              {unreadNotifications}
            </Typography>
          </Box>
        )}
      </Box>

      <Drawer
        title="Notifications"
        titleCounter={unreadNotifications}
        open={open}
        setOpen={setOpen}
        onClose={closeNotificationsHandler}
      >
        {isLoading ? (
          <Box sx={{ marginTop: "50%" }}>
            <Spinner />
          </Box>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                width: "100%"
              }}
            >
              {notifications.length ? (
                <ButtonLink
                  text="Remove All"
                  accessType={isImpersonated ? accessTypes.delete : ""}
                  sx={{ color: tokens.Text.General.Color, marginY: "8px" }}
                  textVariant="body2"
                  underline="none"
                  onClick={() => handleDeleteNotification()}
                />
              ) : (
                <></>
              )}
            </Box>
            <List
              closeNotificationsHandler={closeNotificationsHandler}
              setOpen={setOpen}
              handleDeleteNotification={handleDeleteNotification}
            />
          </>
        )}
      </Drawer>
      <Delete openDeleteDialog={openDeleteDialog} setOpenDeleteDialog={setOpenDeleteDialog} />
    </>
  );
}

export default Index;
